import React from 'react';
import { mockData } from '../mockData';
import { FileCheck, CheckCircle, Award } from 'lucide-react';

const ProcessSection = () => {
  const icons = [FileCheck, CheckCircle, Award];

  return (
    <section className="py-4 md:py-20 bg-navy-800">
      <div className="container mx-auto px-4">
        <div className="text-center md:mb-16 mb-6">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-100 mb-4">
            How It{' '}
            <span className="bg-brand-gradient bg-clip-text text-transparent">
              Works
            </span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Three straightforward steps between you and a federally registered trademark.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {mockData.processSteps.map((step, index) => {
            const Icon = icons[index];
            return (
              <div
                key={step.id}
                className="relative group"
              >
                <div className="bg-gradient-to-br from-navy-800 to-navy-700 rounded-xl p-8 h-full hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
                  <div className="flex items-center justify-between mb-4">
                    <div className="bg-brand-gradient text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl">
                      {step.id}
                    </div>
                    <div className="bg-navy-600 p-3 rounded-full shadow-md group-hover:scale-110 transition-transform">
                      <Icon className="text-brand-primary" size={24} />
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-100 mb-3">{step.title}</h3>
                  <p className="text-gray-300 leading-relaxed">{step.description}</p>
                </div>
                {index < mockData.processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <div className="w-8 h-0.5 bg-gradient-to-r from-gold-400 to-gold-300"></div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
